import HelloSign from 'hellosign-embedded'

export default new HelloSign({
  clientId: '721ee79e55598286a7450ca0ea2ed319'
})
